import { forwardRef, List as ChakraList, ListProps as ChakraListProps } from '@chakra-ui/react';

export type ListColorsType =
  | 'neutral'
  | 'info'
  | 'positive'
  | 'negative'
  | 'warning'
  | 'progress'
  | 'orange'
  | 'turquoise';

export type ListProps = (
  | {
      variant?: 'simple-ordered' | 'unordered' | 'unstyled';
    }
  | {
      colorScheme?: ListColorsType;
      variant?: 'ordered';
    }
) &
  ChakraListProps;

/**
 * List is used to display list items. It renders a <ul> or <ol> element by default.
 */
const List = forwardRef<ListProps, 'ul'>((props, ref) => {
  const { spacing = '8', variant = 'unordered', ...rest } = props;

  let styleType: ListProps['styleType'] = 'none';
  if (variant === 'unordered') {
    styleType = 'initial';
  }
  if (variant === 'simple-ordered') {
    styleType = 'decimal';
  }
  return (
    <ChakraList
      as={variant === 'ordered' || variant === 'simple-ordered' ? 'ol' : 'ul'}
      spacing={spacing}
      styleType={styleType}
      variant={variant}
      {...rest}
      ref={ref}
    />
  );
});

export default List;
